<template>
  <footer>
    <div class="my_footer_w bc_5D5D5D site_min_w">
      <div class="content_w fz12">
        <div class="main_w">
          <div class="div_1 d_flex flex_wrap c_fff">
            <div
              v-for="(item, index) in siteInfo.friendLinks"
              :key="item.url"
              class="link_i"
            >
              <span
                ><a :href="item.url" target="_blank">{{ item.name }}</a></span
              >
              <!-- <span v-if="siteInfo.friendLinks.length>1 && (index+1) !== siteInfo.friendLinks.length" class="span_1">|</span> -->
            </div>
          </div>
          <div style="display: flex">
            <div
              style="width: 88px; height: 70px; margin-top: 22px;margin-left:30px"
              ref="conacContainer"
            ></div>
            <div class="div_2 c_ccc margin_auto">
              <div class="meta-row d_flex justify_content_sb">
                <div class="flex_1 text_left">
                  <span>服务邮箱：</span>
                  <span>{{ siteInfo.email }}</span>
                </div>
                <div class="flex_1 text_left">
                  <span>联系地址：</span>
                  <span>{{ siteInfo.address }}</span>
                </div>
                <div class="flex_1 text_left">
                  <span>运营单位：</span>
                  <span>{{ siteInfo.operatingUnit }}</span>
                </div>
              </div>
              <div class="meta-row d_flex justify_content_sb">
                <div class="flex_1 text_left">
                  <span>主办方：</span>
                  <span>{{ siteInfo.sponsor }}</span>
                </div>
                <div class="flex_1 text_left">
                  <span>技术支持：</span>
                  <span
                    ><a href="https://dihe.cn/" target="_blank"
                      >华远规划设计有限公司</a
                    ></span
                  >
                </div>
                <div class="flex_1 text_left">
                  <span>备案信息：</span>
                  <span
                    ><a href="https://beian.miit.gov.cn/" target="_blank"
                      >粤ICP备2023148226号</a
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="security-link-outer text_center">
            <div class="link-item">备案信息：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023148226号</a></div>
          </div> -->
        </div>
        <!-- <div style="display: flex; align-items: center; justify-content: center; ">
          <div style="margin-left: 65px;text-align: center;" class="c_ccc fz12">
            <img style="width: 120px;margin-top: 24px;margin-bottom: 4px;" src="@/assets/images/publicNumber.jpg" alt="">
            <div>韶关农交公众号</div>
          </div>
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["siteInfo"]),
  },

  created() {},
  mounted() {
    this.loadConacScript();
  },
  methods: {
    loadConacScript() {
      const container = this.$refs.conacContainer;

      // 创建外层控制元素
      const wrapper = document.createElement("div");
      wrapper.className = "conac-icon-wrapper";

      // 添加备案元素
      const span = document.createElement("span");
      span.id = "_ideConac";

      // 创建脚本
      const script = document.createElement("script");
      script.src =
        "https://dcs.conac.cn/js/nis/44/02/00/7e6798e2c7a6fb79560e1000afd65a11/11440200MB2C90821A-20003682.js";
      script.type = "text/javascript";

      // 组装DOM
      wrapper.appendChild(span);
      container.appendChild(wrapper);
      container.appendChild(script);

      script.onload = () => {
        const icon = document.getElementById("_ideConac");
        if (icon) {
          icon.style.width = "50%";
          icon.style.height = "50%";
          // 如果是img
          const img = icon.querySelector("img");
          if (img) {
            img.style.maxWidth = "50%";
            img.style.maxHeight = "50%";
          }
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ba_style {
}
.my_footer_w {
  .content_w {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main_w {
    width: 1198px;
  }
  .div_1 {
    padding: 20px 0;
    border-bottom: 1px solid #b3b3b3;
    .link_i {
      margin: 5px 85px 5px 0;
    }
  }
  .div_2 {
    padding: 20px 0 27px 0;
    width: 1000px;
    margin-left: 75px;
  }
  .meta-row {
    margin: 0 0 22px 0;
    &:last-child {
      margin: 0;
    }
  }
  .span_1 {
    margin: 0 47px;
  }
  .security-link-outer {
    padding: 10px;
    border-top: 1px solid #b3b3b3;
    .link-item {
      color: #ccc;
      margin: 10px;
    }
  }
}
</style>
